import type { Namespace } from '../../../types.js';

export const errors: Namespace = {
  'errors.network': 'Ошибка сети. Попробуйте ещё раз.',
  'errors.forbidden': 'Доступ запрещён.',
  'errors.not_found': 'Не найдено.',
  'errors.unauthorized': 'Требуется вход в систему.',
  'errors.internal': 'Внутренняя ошибка. Мы уже разбираемся.',
};
